export const AUTH_START = 'AUTH_START';
export const AUTH_SUCCESS = 'AUTH_SUCCESS';
export const AUTH_FAIL = 'AUTH_FAIL';
export const AUTH_LOGOUT = 'AUTH_LOGOUT';
export const AUTH_SET_REDIRECT_URL = 'AUTH_SET_REDIRECT_URL';

export const SETTLEMENT_GET_SETTLEMENTS_FROM_SERVER_START = 'SETTLEMENT_GET_SETTLEMENTS_FROM_SERVER_START';
export const SETTLEMENT_GET_SETTLEMENTS_FROM_SERVER_SUCCESS = 'SETTLEMENT_GET_SETTLEMENTS_FROM_SERVER_SUCCESS';
export const SETTLEMENT_GET_SETTLEMENTS_FROM_SERVER_FAIL = 'SETTLEMENT_GET_SETTLEMENTS_FROM_SERVER_FAIL';
export const SETTLEMENT_GET_SETTLEMENTS_FROM_CACHE = 'SETTLEMENT_GET_SETTLEMENTS_FROM_CACHE';
export const SETTLEMENT_SET_SELECTED_SETTLEMENT = 'SETTLEMENT_SET_SELECTED_SETTLEMENT';

export const SETTLEMENT_GET_START = 'SETTLEMENT_GET_START';
export const SETTLEMENT_GET_SUCCESS = 'SETTLEMENT_GET_SUCCESS';
export const SETTLEMENT_GET_FAIL = 'SETTLEMENT_GET_FAIL';

export const CHANGE_PASSWORD_START = 'CHANGE_PASSWORD_START';
export const CHANGE_PASSWORD_SUCCESS = 'CHANGE_PASSWORD_SUCCESS';
export const CHANGE_PASSWORD_FAIL = 'CHANGE_PASSWORD_FAIL';

export const SECURITY_QUESTIONS_CHANGE_START = 'SECURITY_QUESTIONS_CHANGE_START';
export const SECURITY_QUESTIONS_CHANGE_SUCCESS = 'SECURITY_QUESTIONS_CHANGE_SUCCESS';
export const SECURITY_QUESTIONS_CHANGE_FAIL = 'SECURITY_QUESTIONS_CHANGE_FAIL';
export const SECURITY_QUESTIONS_LOAD_START = 'SECURITY_QUESTIONS_LOAD_START';
export const SECURITY_QUESTIONS_LOAD_SUCCESS = 'SECURITY_QUESTIONS_LOAD_SUCCESS';
export const SECURITY_QUESTIONS_LOAD_FAIL = 'SECURITY_QUESTIONS_LOAD_FAIL';

export const ORDER_GET_ORDERS_FROM_SERVER = 'ORDER_GET_ORDERS_FROM_SERVER';
export const ORDER_GET_ORDERS_FROM_SERVER_START = 'ORDER_GET_ORDERS_FROM_SERVER_START';
export const ORDER_GET_ORDERS_FROM_SERVER_SUCCESS = 'ORDER_GET_ORDERS_FROM_SERVER_SUCCESS';
export const ORDER_GET_ORDERS_FROM_SERVER_FAIL = 'ORDER_GET_ORDERS_FROM_SERVER_FAIL';

export const ORDER_GET_ORDER_FROM_SERVER = 'ORDER_GET_ORDER_FROM_SERVER';
export const ORDER_GET_ORDER_FROM_SERVER_START = 'ORDER_GET_ORDER_FROM_SERVER_START';
export const ORDER_GET_ORDER_FROM_SERVER_SUCCESS = 'ORDER_GET_ORDER_FROM_SERVER_SUCCESS';
export const ORDER_GET_ORDER_FROM_SERVER_FAIL = 'ORDER_GET_ORDER_FROM_SERVER_FAIL';

export const LOG_GET_LOGS_FROM_SERVER = 'LOG_GET_LOGS_FROM_SERVER';
export const LOG_GET_LOGS_FROM_SERVER_START = 'LOG_GET_LOGS_FROM_SERVER_START';
export const LOG_GET_LOGS_FROM_SERVER_SUCCESS = 'LOG_GET_LOGS_FROM_SERVER_SUCCESS';
export const LOG_GET_LOGS_FROM_SERVER_FAIL = 'LOG_GET_LOGS_FROM_SERVER_FAIL';

export const LANDING_PAGE_GET_SUMMARY = 'LANDING_PAGE_GET_SUMMARY';
export const LANDING_PAGE_GET_SUMMARY_START = 'LANDING_PAGE_GET_SUMMARY_START';
export const LANDING_PAGE_GET_SUMMARY_SUCCESS = 'LANDING_PAGE_GET_SUMMARY_SUCCESS';
export const LANDING_PAGE_GET_SUMMARY_FAIL = 'LANDING_PAGE_GET_SUMMARY_FAIL';

export const A2HS_SUCCESS = 'A2HS_SUCCESS';
export const A2HS_SAVE_EVENT = 'A2HS_SAVE_EVENT';
export const A2HS_CLEAR = 'A2HS_CLEAR';